module.exports = __webpack_public_path__ + "media/images/athletes/161-c5d44ede873a68b08724c7bc488c5470.png";